import { FONT_HEAD, FONT_BODY, GOLD } from "../lib/constants";

export const Logo = ({ theme = "light" }) => {
  const textColor = theme === "dark" ? "#FFFFFF" : "#1B3A6B";
  const cStroke = theme === "dark" ? "#FFFFFF" : "#183A6B";

  return (
    <div className="flex items-center gap-2.5" data-testid="logo">
      <svg viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg" width="42" height="42" style={{ flexShrink: 0 }}>
        <path d="M 75 30 C 65 15, 45 10, 30 25 C 15 40, 15 60, 30 75 C 45 90, 65 85, 75 70" stroke={cStroke} strokeWidth="12" strokeLinecap="round" />
        <path d="M 25 65 C 40 85, 80 85, 90 55" stroke="#D4A843" strokeWidth="6" strokeLinecap="round" />
        <path d="M 75 15 C 75 22, 82 25, 88 25 C 82 25, 75 28, 75 35 C 75 28, 68 25, 62 25 C 68 25, 75 22, 75 15 Z" fill="#D4A843" />
        <path d="M 20 20 C 20 23, 23 25, 26 25 C 23 25, 20 27, 20 30 C 20 27, 17 25, 14 25 C 17 25, 20 23, 20 20 Z" fill={cStroke} opacity="0.5" />
      </svg>
      <div className="leading-tight">
        <div className="font-bold text-lg leading-none" style={{ fontFamily: FONT_HEAD, color: textColor }}>
          Cindyrella
        </div>
        <div className="text-xs tracking-widest" style={{ color: GOLD, fontFamily: FONT_BODY, letterSpacing: "0.16em" }}>
          CLEANING LLC
        </div>
      </div>
    </div>
  );
};
